<template>
  <div>
    <img v-if="currentPath!=='/login' && currentPath!=='/register'" :src="BottomImg" style="width:100%;" alt="">
    <div class="footer-title" style="color:#888; font-size:12px" v-html="LoginBrowse"></div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      LoginBrowse: '<p>Please use web browsers such as Google Chrome, Mozilla Firefox, IE 10 or above.</p>',
      // LoginBrowse: sessionStorage.getItem('LoginBrowse') || '<p>Please use web browsers such as Google Chrome, Mozilla Firefox, IE 10 or above.</p>',
      BottomImg: sessionStorage.getItem('BottomImg') || '',
      currentPath: ''
    }
  },
  mounted() {
    this.currentPath = this.$route.path
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue